// extracted by mini-css-extract-plugin
module.exports = {"primary-button":"ButtonCmp_primary-button__WrS_R","secondary-button":"ButtonCmp_secondary-button__v01RT"};